var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.selectedTab.type == _vm.ItemCategoryTypes.RR ||
    _vm.selectedViewType != _vm.viewTypes.tabbedView
      ? _c(
          "div",
          { staticClass: "mb-5" },
          [
            _c("quote-builder-labour-headings-component", {
              attrs: {
                name: _vm.rrCategory?.displayName || "Remove & Refit",
                "is-full-width": _vm.isFullWidth,
                "is-quote-hour": _vm.isQuoteTypeHour,
                count: _vm.rrLength,
                "total-value": _vm.rrTotal,
                "hour-value": _vm.rrHourTotal,
                "is-ntar": _vm.isNtar,
                "next-line-number": _vm.nextLineNumber,
              },
            }),
            _c(
              "div",
              { staticClass: "rows" },
              [
                _c(
                  "draggable",
                  _vm._b(
                    {
                      attrs: {
                        clone: ($event) =>
                          _vm.cloneHandler($event, _vm.ItemCategoryTypes.RR),
                        group: {
                          name: _vm.ItemCategoryTypes.RR,
                          pull: "clone",
                          put: true,
                        },
                        handle: ".item-drag-handle",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.itemMoved($event, _vm.ItemCategoryTypes.RR)
                        },
                        over: function ($event) {
                          $event.preventDefault()
                        },
                        enter: function ($event) {
                          $event.preventDefault()
                        },
                      },
                      model: {
                        value: _vm.innerValue.labours,
                        callback: function ($$v) {
                          _vm.$set(_vm.innerValue, "labours", $$v)
                        },
                        expression: "innerValue.labours",
                      },
                    },
                    "draggable",
                    {
                      disabled: !_vm.isRowDraggable,
                      ghostClass: "draggable-ghost",
                      dragClass: "draggable-drag",
                    },
                    false
                  ),
                  _vm._l(_vm.innerValue.labours, function (item) {
                    return _c(
                      "div",
                      { key: item.quoteItemId + _vm.ItemCategoryTypes.RR },
                      [
                        item.itemType == _vm.ItemCategoryTypes.RR
                          ? _c("quote-builder-labour-item", {
                              attrs: {
                                "read-only-view": _vm.readOnlyView,
                                vehicle: _vm.vehicle,
                                "inner-value": _vm.innerValue,
                                "items-assessments": _vm.itemsAssessments,
                                "is-quote-type-hour": _vm.isQuoteTypeHour,
                                "is-full-width": _vm.isFullWidth,
                                item: item,
                                "is-selected":
                                  _vm.editItemObj.id === item.quoteItemId,
                                "fully-expanded":
                                  _vm.editItemObj.isFullyExpanded,
                                "is-ntar": _vm.isNtar,
                                "next-line-number": _vm.nextLineNumber,
                                "is-editable": !_vm.readOnlyComputed,
                              },
                              on: {
                                deleteItem: _vm.deleteItem,
                                updateValue: _vm.updateValue,
                                focusNextRow: (id) =>
                                  _vm.$emit("focusNextRow", item),
                                handlePresentAs: (itemId) =>
                                  _vm.$emit("handlePresentAs", itemId),
                                itemRowClicked: (value, event, expand, close) =>
                                  _vm.$emit(
                                    "handleItemRowClick",
                                    value,
                                    event,
                                    expand,
                                    close
                                  ),
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ],
              1
            ),
            _c("div", [
              _c(
                "button",
                {
                  staticClass: "button is-outlined is-primary",
                  attrs: { disabled: _vm.readOnlyComputed },
                  on: {
                    click: function ($event) {
                      return _vm.addBlankItem($event, _vm.ItemCategoryTypes.RR)
                    },
                  },
                },
                [_vm._v(" + Add Item ")]
              ),
            ]),
          ],
          1
        )
      : _vm._e(),
    _vm.selectedTab.type == _vm.ItemCategoryTypes.REP ||
    _vm.selectedViewType != _vm.viewTypes.tabbedView
      ? _c(
          "div",
          { staticClass: "mb-5" },
          [
            _c("quote-builder-labour-headings-component", {
              attrs: {
                name: _vm.repCategory?.displayName || "Repair",
                "is-full-width": _vm.isFullWidth,
                "is-quote-hour": _vm.isQuoteTypeHour,
                count: _vm.repLength,
                "total-value": _vm.repairTotal,
                "hour-value": _vm.repairHourTotal,
                "is-ntar": _vm.isNtar,
                "show-loading": _vm.isNtar,
                "next-line-number": _vm.nextLineNumber,
              },
            }),
            _c(
              "div",
              { staticClass: "rows" },
              [
                _c(
                  "draggable",
                  _vm._b(
                    {
                      attrs: {
                        clone: ($event) =>
                          _vm.cloneHandler($event, _vm.ItemCategoryTypes.REP),
                        group: {
                          name: _vm.ItemCategoryTypes.REP,
                          pull: "clone",
                          put: true,
                        },
                        handle: ".item-drag-handle",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.itemMoved(
                            $event,
                            _vm.ItemCategoryTypes.REP
                          )
                        },
                        over: function ($event) {
                          $event.preventDefault()
                        },
                        enter: function ($event) {
                          $event.preventDefault()
                        },
                      },
                      model: {
                        value: _vm.innerValue.labours,
                        callback: function ($$v) {
                          _vm.$set(_vm.innerValue, "labours", $$v)
                        },
                        expression: "innerValue.labours",
                      },
                    },
                    "draggable",
                    {
                      disabled: !_vm.isRowDraggable,
                      chosen: "chosen",
                      ghostClass: "draggable-ghost",
                      dragClass: "draggable-drag",
                    },
                    false
                  ),
                  _vm._l(_vm.innerValue.labours, function (item) {
                    return _c(
                      "div",
                      { key: item.quoteItemId + _vm.ItemCategoryTypes.REP },
                      [
                        item.itemType == _vm.ItemCategoryTypes.REP
                          ? _c("quote-builder-labour-item", {
                              attrs: {
                                "inner-value": _vm.innerValue,
                                "read-only-view": _vm.readOnlyView,
                                "items-assessments": _vm.itemsAssessments,
                                vehicle: _vm.vehicle,
                                "is-full-width": _vm.isFullWidth,
                                "is-quote-type-hour": _vm.isQuoteTypeHour,
                                item: item,
                                "is-selected":
                                  _vm.editItemObj.id === item.quoteItemId,
                                "fully-expanded":
                                  _vm.editItemObj.isFullyExpanded,
                                "show-loading": _vm.isNtar,
                                "is-ntar": _vm.isNtar,
                                "next-line-number": _vm.nextLineNumber,
                                "is-editable": !_vm.readOnlyComputed,
                              },
                              on: {
                                deleteItem: _vm.deleteItem,
                                updateValue: _vm.updateValue,
                                focusNextRow: (id) =>
                                  _vm.$emit("focusNextRow", item),
                                handlePresentAs: (itemId) =>
                                  _vm.$emit("handlePresentAs", itemId),
                                itemRowClicked: (value, event, expand, close) =>
                                  _vm.$emit(
                                    "handleItemRowClick",
                                    value,
                                    event,
                                    expand,
                                    close
                                  ),
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ],
              1
            ),
            _c("div", [
              _c(
                "button",
                {
                  staticClass: "button is-outlined is-primary",
                  attrs: { disabled: _vm.readOnlyComputed },
                  on: {
                    click: function ($event) {
                      return _vm.addBlankItem($event, _vm.ItemCategoryTypes.REP)
                    },
                  },
                },
                [_vm._v(" + Add Item ")]
              ),
            ]),
          ],
          1
        )
      : _vm._e(),
    _vm.selectedTab.type == _vm.ItemCategoryTypes.PAINT ||
    _vm.selectedViewType != _vm.viewTypes.tabbedView
      ? _c(
          "div",
          { staticClass: "mb-5" },
          [
            _c("quote-builder-labour-headings-component", {
              attrs: {
                name: _vm.paintCategory?.displayName || "Paint",
                "is-quote-hour": _vm.isQuoteTypeHour,
                "is-paint-item": true,
                count: _vm.paintLength,
                "total-value": _vm.paintTotal,
                "hour-value": _vm.paintHourTotal,
                "is-full-width": _vm.isFullWidth,
                "is-ntar": _vm.isNtar,
                "next-line-number": _vm.nextLineNumber,
              },
            }),
            _c(
              "div",
              { staticClass: "rows" },
              [
                _c(
                  "draggable",
                  _vm._b(
                    {
                      attrs: {
                        clone: ($event) =>
                          _vm.cloneHandler($event, _vm.ItemCategoryTypes.PAINT),
                        group: {
                          name: _vm.ItemCategoryTypes.PAINT,
                          pull: "clone",
                          put: true,
                        },
                        handle: ".item-drag-handle",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.itemMoved(
                            $event,
                            _vm.ItemCategoryTypes.PAINT
                          )
                        },
                        over: function ($event) {
                          $event.preventDefault()
                        },
                        enter: function ($event) {
                          $event.preventDefault()
                        },
                      },
                      model: {
                        value: _vm.innerValue.labours,
                        callback: function ($$v) {
                          _vm.$set(_vm.innerValue, "labours", $$v)
                        },
                        expression: "innerValue.labours",
                      },
                    },
                    "draggable",
                    {
                      disabled: !_vm.isRowDraggable,
                      chosen: "chosen",
                      ghostClass: "draggable-ghost",
                      dragClass: "draggable-drag",
                    },
                    false
                  ),
                  _vm._l(_vm.innerValue.labours, function (item) {
                    return _c(
                      "div",
                      { key: item.quoteItemId },
                      [
                        item.itemType == _vm.ItemCategoryTypes.PAINT
                          ? _c("quote-builder-labour-item", {
                              attrs: {
                                "inner-value": _vm.innerValue,
                                "is-quote-type-hour": _vm.isQuoteTypeHour,
                                "is-full-width": _vm.isFullWidth,
                                vehicle: _vm.vehicle,
                                "items-assessments": _vm.itemsAssessments,
                                "read-only-view": _vm.readOnlyView,
                                item: item,
                                "is-paint": true,
                                "is-selected":
                                  _vm.editItemObj.id === item.quoteItemId,
                                "fully-expanded":
                                  _vm.editItemObj.isFullyExpanded,
                                "is-ntar": _vm.isNtar,
                                "next-line-number": _vm.nextLineNumber,
                                "is-editable": !_vm.readOnlyComputed,
                              },
                              on: {
                                deleteItem: _vm.deleteItem,
                                onOpgCodeChanged: function ($event) {
                                  return _vm.$emit("onOpgCodeChanged")
                                },
                                updateValue: _vm.updateValue,
                                focusNextRow: (id) =>
                                  _vm.$emit("focusNextRow", item),
                                handlePresentAs: (itemId) =>
                                  _vm.$emit("handlePresentAs", itemId),
                                itemRowClicked: (value, event, close) =>
                                  _vm.$emit(
                                    "handleItemRowClick",
                                    value,
                                    event,
                                    close
                                  ),
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ],
              1
            ),
            _c("div", [
              _c(
                "button",
                {
                  staticClass: "button is-outlined is-primary",
                  attrs: { disabled: _vm.readOnlyComputed },
                  on: {
                    click: function ($event) {
                      return _vm.addBlankItem(
                        $event,
                        _vm.ItemCategoryTypes.PAINT
                      )
                    },
                  },
                },
                [_vm._v(" + Add Item ")]
              ),
            ]),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }